import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Direccione } from '../model/third_model';
import { RaizComponent } from '../raiz/raiz.component';
import { AuthService } from '../_services/auth.service';
import { InfoService } from '../_services/info.service';
import { NotificationService } from '../_services/notification.service';
import { ServicioGeneral } from '../_services/servicio-general.service';
import { TokenStorageService } from '../_services/token-storage.service';
import { UserService } from '../_services/user.service';
import { ClientLoaderService } from '../core/util/client-loader.service';
import { NotificationI18nService } from '../core/util/notification-i18n.service';


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent extends UnsubscribeOnDestroy implements OnInit {
  
  @Input() direccion?: Direccione | undefined ;

  checkPasswords: ValidatorFn = (group: AbstractControl):  ValidationErrors | null => { 
    let password = group.get('password').value;
    let confirmPassword = group.get('password_confirmacion').value
    return password === confirmPassword ? null : { notSame: true }
  }

  form: UntypedFormGroup = new UntypedFormGroup( {
    nombre: new UntypedFormControl("", Validators.required), 
    email: new UntypedFormControl("", Validators.required),
    password: new UntypedFormControl("", [Validators.required, Validators.minLength(6)]),
    password_confirmacion: new UntypedFormControl("", [Validators.required,]),
    apellido1: new UntypedFormControl("", Validators.required),
    apellido2: new UntypedFormControl(""),
    tipo_persona: new UntypedFormControl("", Validators.required),
    tipo_documento : new UntypedFormControl("", Validators.required),
    telefono : new UntypedFormControl("", [Validators.required, Validators.pattern("[0-9]{9}")]),
    numero_documento : new UntypedFormControl("", Validators.required),
    tipo_via: new UntypedFormControl("", Validators.required),
    nombre_via: new UntypedFormControl("", Validators.required),
    numero_via: new UntypedFormControl("",Validators.required),
    bloque: new UntypedFormControl(""),
    escalera: new UntypedFormControl(""),
    piso: new UntypedFormControl(""),
    puerta: new UntypedFormControl(""),
    codigo_postal: new UntypedFormControl("", [Validators.required, Validators.pattern("^(?:0[1-9]\\d{3}|[1-4]\\d{4}|5[0-2]\\d{3})$")]),
    pais: new UntypedFormControl("", Validators.required),
    ccaa: new UntypedFormControl("", Validators.required),
    provincia: new UntypedFormControl("", Validators.required),
    municipio: new UntypedFormControl("", Validators.required),
  }, { validators: this.checkPasswords });

  isSuccessful = false;
  isSignUpFailed = false;
  errorMessage = '';
  TPersonas: any = [];
  TDocumentos: any = [];
  TComunidades: any = [];
  TProvincias: any = [];
  provincias = this._servicioGeneral.getProvincias();
  TMunicipios: any = [];
  municipios = this._servicioGeneral.getMunicipios();
  TVias: any = [];
  TPais: any = [];
  submitted: boolean = false;
  register = false;
  InfoRegistro: any = [];
  environment = environment;
  logoPanelUrl = '';

  constructor(
    private _authService: AuthService,
    private _servicioGeneral: ServicioGeneral,
    private _notificationI18n: NotificationI18nService,
    private _router: Router,
    private _infoService: InfoService,
    private _tokenStorage : TokenStorageService,
    private _userService: UserService,
    private raiz: RaizComponent,
    private clientLoader: ClientLoaderService,
    ) {
    super();
  }

  ngOnInit(): void {
    this.logoPanelUrl = this.clientLoader.getClientImage('panel');
    this.getDocumentos();
    this.getTipoPersona();
    this.getVias();
    this.getPais();
    this.getComunidades();
    this.getProvincias();
    this.getInformacion();
    this.register = false;
  }

  async onSubmit(): Promise<any> {
    this.submitted = true;
    this.register = false;

    if(this.form.get('telefono').hasError('pattern')){
      this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_ES_UN_TELEFONO_VALIDO', 5000);
      return false;
    }

    if(this.form.get('codigo_postal').hasError('pattern')){
      this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_ES_UN_CODIGO_POSTAL_VALIDO', 5000);
      return false;
    }

    if(this.form.get('password').hasError('minLength')){
      this._notificationI18n.error('NOTIFICATION.MESSAGE.LA_CONTRASENA_DEBE_TENER_AL_MENOS_6_CARACTERES', 5000);
      return false;
    }

    if(this.form.hasError('notSame')){
      this._notificationI18n.error('NOTIFICATION.MESSAGE.LAS_CONTRASENAS_NO_COINCIDEN', 5000);
      this.form.controls['password_confirmacion'].setErrors({'incorrect': true});
      return false;
    }

    if(!this.form.valid) {
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.RELLENE_TODOS_LOS_CAMPOS_POR_FAVOR', 5000);
      return false;
    } else {
      this.register = true;
      this._authService.register(
        this.form.get('nombre').value,
        this.form.get('apellido1').value,
        this.form.get('apellido2').value,
        this.form.get('email').value,
        this.form.get('password').value,
        this.form.get('tipo_persona').value,
        this.form.get('tipo_documento').value,
        this.form.get('numero_documento').value,
        this.form.get('telefono').value,
        this.form.get('tipo_via').value as string,
        this.form.get('nombre_via').value,
        this.form.get('numero_via').value,
        this.form.get('bloque')?.value,
        this.form.get('escalera')?.value,
        this.form.get('piso')?.value,
        this.form.get('puerta')?.value,
        this.form.get('codigo_postal').value,
        this.form.get('pais').value,
        this.form.get('ccaa').value,
        this.form.get('provincia').value,
        this.form.get('municipio').value
        )
          .pipe(takeUntil(this.destroy$))
          .subscribe({  
        next: async data => {  
          this.register = true;

          this._notificationI18n.info('NOTIFICATION.MESSAGE.SE_HA_ENVIADO_UN_EMAIL_DE_CONFIRMACION_A_SU_CUENTA_DE_CORREO_ELECTRONICO_SI_DESE');
          // this._notificationI18n.success('NOTIFICATION.MESSAGE.SE_HA_REGISTRADO_CON_EXITO', 50000);          
          this._tokenStorage.saveToken(data.accessToken);
          this._userService.getCurrentUserFromServer()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
            next: (data) => {
              if (this.environment.environment == 'novotaxi') {
                this._router.navigateByUrl('/admin-novotaxi').then(() => {
                  this._router.navigate(['admin-novotaxi']);
                });
              } else {
                this._tokenStorage.setUser(data.Usuario,data.usuarioRepresenta);
                this.raiz.reloadHeader=!this.raiz.reloadHeader;
                this._router.navigate(['/inicio']);
              }
            },
            error: (error) => {
              this._router.navigate(['/inicio']);
            }
          }); 
          this.isSignUpFailed = false; 
        },
        error: err => {
          //console.log(err);
          this.register = false;
          
          if(err.status == 226){
            this._notificationI18n.errorDynamic(err.error.text, 50000);
            this.form.controls['numero_documento'].setErrors({'incorrect': true});
          } 
          else if(err.error.status == 651){
            this._notificationI18n.errorRedir(
              'COMMON.NOTIFICATION.ERROR',
              'REGISTER.ERROR.INACTIVE_USER_DOC',
              50000,
              'REGISTER.ERROR.RESET_LINK',
              '../forgot-password'
            );
          }
          else if(err.status == 406){
            this._notificationI18n.errorDynamic(err.error , 50000);
            this.form.controls['numero_documento'].setErrors({'incorrect': true});
          } 
          else {
            this.form.controls['numero_documento'].setErrors({'incorrect': false});
          }

          if(err.error.status == 628){
            this._notificationI18n.errorDynamic(err.error , 50000);
            this.form.controls['email'].setErrors({'incorrect': true});
          }

          if(err.error.status == 627){
            this._notificationI18n.errorDynamic(err.error , 50000);
            this.form.controls['email'].setErrors({'incorrect': true});
          }
          this.isSignUpFailed = true;
        }
      });
    }
  }

  getTipoPersona() {
    return this._servicioGeneral.getTipoPersona()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
      this.TPersonas = data['TipoPersona'];
    });
  }

  getDocumentos() {
    return this._servicioGeneral.getTipoDocumento()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
      this.TDocumentos = data['TipoDocumento'];
    });
  }
  
  get documento() {
    return this.form.get("numero_documento");
  }

  getComunidades() {
    return this._servicioGeneral.getComunidades()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
      this.TComunidades = data['ComunidadAutonoma'];
    });
  }

  getProvincias() {
    return this._servicioGeneral.getProvincias()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
      this.TProvincias = data['Provincia'];
    });
  }

  onChangeProvincia(event: Event) {
    this.TProvincias = [];
    const id = (event.target as HTMLInputElement).value;
    this.getProvinciasByID(id);
  }

  getProvinciasByID(id: string) {
    this.provincias
      .pipe(takeUntil(this.destroy$))
      .subscribe(
      (data) => {
        data['Provincia'].forEach((provincia) => {
          if (provincia.ccaa["id"] == id) {
              this.TProvincias.push(provincia);
              return this.TProvincias;
            }
        });
      });
  }

  getMunicipios() {
    if(!this.direccion?.province["id"]){
      return this._servicioGeneral.getMunicipios()
        .pipe(takeUntil(this.destroy$))
        .subscribe((data) => {
        this.TMunicipios = data;
      });
    }else{
      return this.getMunicipiosByID(this.direccion?.province["id"])
    }
  }

  onChangeMunicipio(event: Event) {
    this.TMunicipios = [];
    const id = (event.target as HTMLInputElement).value;
    this.getMunicipiosByID(id);
  }

  getMunicipiosByID(id: string) {
    this.municipios
      .pipe(takeUntil(this.destroy$))
      .subscribe( (data) =>{
      data['Municipio'].forEach((municipio) => {
        if(municipio.municipioPK["provincia"] == id){
          this.TMunicipios.push(municipio);
          return this.TMunicipios
        }
      });
    });
  }

  getVias() {
    return this._servicioGeneral.getTipoVias()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
      this.TVias = data['TipoVia'];
    });
  }

  getPais() {
    return this._servicioGeneral.getPais()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
      this.TPais = data['Pais'];
    });
  }

  getInformacion() {
    return this._infoService.getInfRegistro()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
      
      this.InfoRegistro = data.Informacion;
    })
  }
}
